import { ProxyBusinessPartnerFormData } from '../../hooks/forms/useBusinessPartnerForm';
import { BusinessPartnerForm } from './BusinessPartnerForm';

interface CustomerFormProps {
  formName: string;
  isPending: boolean;
  handleFormSubmit: () => void;
  formFields: ProxyBusinessPartnerFormData;
  setFormFields: (fields: ProxyBusinessPartnerFormData) => void;
  /** Renders a dismissible "please verify" banner above the General Information fields. */
  showVerifyBanner?: boolean;
  /** Called when the verify banner is dismissed; the parent owns the dismissed state. */
  onDismissVerifyBanner?: () => void;
}

function CustomerForm({
  formName,
  isPending,
  handleFormSubmit,
  formFields,
  setFormFields,
  showVerifyBanner,
  onDismissVerifyBanner,
}: CustomerFormProps) {
  return (
    <BusinessPartnerForm
      businessPartnerType="proxy"
      formName={formName}
      isPending={isPending}
      handleFormSubmit={handleFormSubmit}
      formFields={formFields}
      setFormFields={(fields) => setFormFields(fields as ProxyBusinessPartnerFormData)}
      useLocationSuggestion={true}
      showVerifyBanner={showVerifyBanner}
      onDismissVerifyBanner={onDismissVerifyBanner}
    />
  );
}

export default CustomerForm;
